import React, { Component, useReducer } from 'react';
import {Collapse,Navbar,NavbarToggler,NavbarBrand,Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Table, Form, FormGroup, Container, Label, InputGroup} from "reactstrap";
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import axios from 'axios';
import Background from '../images/image_3.jpg'
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
//import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { Triangle } from 'react-loader-spinner';


  class ForgotPassword extends Component{
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
        show_network_error: false,
        button_disabled: false,
        email: '',
        status: 'Reset password'
    };
    this.ResendPasswordResetEmail = () => {
        const email = this.state.email;

        if(email==''){
            alert('Email address field cannot be empty')
        }else{
            axios.post(Backend_Url + 'initiatePasswordReset/' + email)
            .then((res) => {
                let result = res.data
                if(result=='User not found'){
                    this.setState({status: 'User not found'})
                }else if(result=='Reset email sent'){
                    this.setState({status: 'Reset email sent'})
                }else if(result=='Email address not valid'){
                    this.setState({status: 'Email address not valid'})
                }
            }).catch((error) => {
              this.ServerErrorEncountered()
            })
        }
    }
    this.ShowNetworkErrorMessage = () => {
        var show = this.state.show_network_error
        if(show==true){
            return<h6 style={{color: 'red', marginTop: ''}}>
                There seems to be a problem connecting to our servers. Please check your network connection and try again.
            </h6>
        }else{
            return<div></div>
        }
    }
    
    this.SelectRender = () => {
        var status = this.state.status
        if(status == 'Reset password'){
            return<div>
                <br/>
                <this.ShowNetworkErrorMessage/>
                <h6>
                    Enter the email address you used during signup
                </h6>
                <br/><br/>
                <Row>
                    <Col style={{paddingLeft: '100px', paddingRight: '100px'}}>
                    <Input style={{border: 'none', borderBottom: '1px solid #1faced', backgroundColor: 'inherit'}} placeholder="Enter your email address here" type="text" name="email" id="email"
                        value={this.state.email} onChange={this.HandleChange} />
                    </Col>
                </Row>
                <br/><br/><br/>
                <Button disabled={this.state.button_disabled} onClick={this.InitiatePasswordReset} style={{backgroundColor: '#1faced', border: 'none'}}>
                      Reset Password
                </Button>
            </div>
        }else if(status=='Loading'){
            return<div>
                <br/>
                <h1 style={{color: '#47525E', fontFamily: 'Knewave', marginTop: '50px', fontWeight: 'bold'}}>
                ONFIT
                </h1>
                <br/><br/>
                <Triangle
                    color="#1FACED"
                    height={130}
                    width={130}
                />
                <h3 style={{marginTop: '50px'}}>
                Loading...
                </h3>
                <h6 style={{marginTop: '50px'}}>
                    Taking too long to load? Check your internet connection and reload the page.
                </h6>
                <br/><br/>
            </div>
        }else if(status=='User not found'){
            return<div>
                <br/><br/><br/>
                <h5>
                    The email address you've provided ({this.state.email}) is not linked to any verified account on this platform
                </h5>
                <br/><br/><br/>
                <Button disabled={this.state.button_disabled} onClick={this.TryAgain} style={{backgroundColor: '#1faced', border: 'none'}}>
                      Try Again
                </Button>
            </div>
        }else if(status=='Reset email sent'){
            return<div>
                <br/><br/><br/>
                <h5>
                    We've sent instructions to {this.state.email}, follow them to reset your password
                </h5>
                <h6 style={{marginTop: '100px'}}>
                    Did not receive our email? Click the button below to resend.
                </h6>
                <br/>
                <Button disabled={this.state.button_disabled} onClick={this.ResendPasswordResetEmail} style={{backgroundColor: '#1faced', border: 'none'}}>
                  Resend password reset email
                </Button>     
            </div>
        }else if(status=='Email address not valid'){
            return<div>
                <br/><br/><br/>
                <h5>
                    The email address you've provided ({this.state.email}) is not valid
                </h5>
                <br/><br/><br/>
                <Button disabled={this.state.button_disabled} onClick={this.TryAgain} style={{backgroundColor: '#1faced', border: 'none'}}>
                      Try Again
                </Button>
            </div>
        }else{
            return<div>
                <br/><br/><br/>
                <h1 style={{fontWeight: 'bold'}}>
                  Onfit
                </h1>
                <h3 style={{marginTop: '80px'}}>
                  Loading...
                </h3>
                <h6 style={{marginTop: '50px'}}>
                    Taking too long to load? Check your internet connection and reload the page.
                </h6>
            </div>
        }
    }
    this.InitiatePasswordReset = (e) =>{
        this.setState({status: 'Loading', button_disabled: true})
        e.preventDefault();
        const email = this.state.email;

        if(email==''){
            alert('Email address field cannot be empty')
        }else{
            axios.get(Backend_Url + 'initiatePasswordReset/' + email)
            .then((res) => {
                let result = res.data
                if(result=='User not found'){
                    this.setState({status: 'User not found'})
                }else if(result=='Reset email sent'){
                    this.setState({status: 'Reset email sent'})
                }else if(result=='Email address not valid'){
                    this.setState({status: 'Email address not valid'})
                }
                this.setState({button_disabled: false})
            }).catch((error) => {
                this.setState({show_network_error: true, status: 'Reset password', button_disabled: false})
            })
        }
    };

    
    this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
    };
    }

    componentDidMount() {
      const { cookies } = this.props;
      if(cookies.get('token')!=null){
        let port = (window.location.port ? ':' + window.location.port : '');
        window.location.href = '//' + window.location.hostname + port + '/user-home';
      };
  }

    render() {
      return (
        <div style={{backgroundImage: "url(" + Background + ")"}}>
          <div style={{backgroundColor: '#FFFFFF', opacity: 0.85, minHeight: '550px'}}>
            <Helmet>
            <title>Forgot password - Onfit</title>
            {/* <meta name="description" content="Forgot your password? Request a password reset here." /> */}
            </Helmet>
            <Container>
                <br/><br/>
                <h4 style={{color: '#1faced'}}>
                    Forgot Password
                </h4>
                <this.SelectRender/>
            </Container>
          </div>
        </div>
      );
    }

  };
  
  export default withCookies(ForgotPassword);